/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import Auth from '../../utils/Auth';
import StrataAdminLayout from '../layout/strataAdmin/StrataAdminLayout';

export default (props) => (
  <>
    {Auth.isAuthenticated(['strataAdmin', 'superAdmin']) ? (
      <StrataAdminLayout>
        <Route {...props} />
      </StrataAdminLayout>
    ) : (
      <Redirect to="/" />
    )}
  </>
);
